{
  "en": {
    "bookmark": {
      "hints": {
        "body": "Discover free teaching materials in the fobizz gallery and get inspiration for your lessons. You can bookmark the material by clicking on the <i class='bi bi-heart'></i>.",
        "title": "You haven’t bookmarked anything yet"
      },
      "links": {
        "toMaterial": "Discover teaching material"
      },
      "title": "Bookmarked teaching materials"
    }
  }
}
